export const translations = {
  es: {
    appName: "Planificador de Planes",
    tagline: "Decidnos cuántos sois, qué presupuesto tenéis y qué os apetece. Os proponemos planes reales de la zona, con precio y cómo llegar.",
    people: "Personas",
    budgetPerPerson: "Presupuesto por persona (€)",
    mood: "¿Qué os apetece?",
    moodPlaceholder: "naturaleza, aventura, tapas, escape room...",
    maxDistance: "Distancia máxima",
    upTo: "Hasta",
    km: "km",
    location: "Vuestra ubicación",
    locationPlaceholder: "Ej: Buendía, Madrid, Valencia...",
    searchPlans: "Buscar planes",
    searching: "Buscando planes...",
    plansCount: (n, p) => `${n} plan(es) para ${p} persona(s)`,
    perPerson: "/persona",
    totalGroup: "Total grupo",
    overBudget: (e) => `Se pasa de vuestro presupuesto por ~${e} €/persona`,
    save: "Guardar",
    saved: "Guardado",
    login: "Iniciar sesión",
    register: "Crear cuenta",
    logout: "Salir",
    email: "Email",
    password: "Contraseña",
    name: "Nombre",
    loginTitle: "Bienvenido de vuelta",
    registerTitle: "Únete a la aventura",
    noAccount: "¿No tienes cuenta?",
    haveAccount: "¿Ya tienes cuenta?",
    favorites: "Mis planes",
    emptyFav: "Aún no tienes planes guardados.",
    delete: "Eliminar",
    home: "Inicio",
    heroBadge: "Planes reales · IA local",
    heroTitle: "El plan perfecto en 30 segundos",
    heroSub: "Escapadas, tapas, aventura y más — a medida para tu grupo.",
    loginToSave: "Inicia sesión para guardar tus planes favoritos",
    signup: "Registrarse",
    aiError: "No pudimos generar los planes. Prueba a ajustar tus filtros.",
    budgetError: "⚠️ Sin saldo en la clave de IA. Ve a Perfil → Gestionar plan → Universal Key → Añadir saldo y vuelve a intentarlo.",
    rateLimitError: "Demasiadas peticiones seguidas. Espera unos segundos y prueba otra vez.",
    within: "Dentro de presupuesto",
    generatingSub: "Nuestra IA está mirando la zona de {loc}...",
    continueGoogle: "Continuar con Google",
    orDivider: "o",
    bookNow: "Reservar",
    findOnline: "Ir a la web",
    bookPlan: "Reservar este plan",
    exploreOnline: "Abrir web del plan",
    aiEngine: "Motor de IA",
    date: "Fecha",
    pickDate: "Elegir fecha",
    withKids: "Con niños",
    duration: "Duración",
    halfDay: "Medio día",
    fullDay: "Día completo",
    weatherAware: "Tener en cuenta el clima",
    surpriseMe: "Sorpréndeme",
    tryAgain: "No me convence ninguno",
    holiday: "Festivo",
    weather: "Clima",
    rainProb: "Prob. lluvia",
    requiresBooking: "Requiere reserva",
    noBooking: "Sin reserva previa",
    kidFriendly: "Apto niños",
    indoor: "Interior",
    outdoor: "Exterior",
    duration_h: (h) => `~${h}h`,
    share: "Compartir",
    shareWhatsapp: "Enviar por WhatsApp",
    groupVote: "Votación en grupo",
    creatingShare: "Creando enlace...",
    voteFor: "Vota tu favorito",
    voterName: "Tu nombre",
    vote: "Votar",
    voted: "Voto registrado",
    votesCount: (n) => `${n} voto(s)`,
    groupWinner: "Plan ganador",
    ratingUp: "Nos gustó",
    ratingDown: "No nos gustó",
    markDone: "Marcar como hecho",
    marked: "Hecho",
    filters: "Filtros",
    moreFilters: "Más filtros",
    hideFilters: "Ocultar filtros",
    ageRange: "Rango de edad",
    ageRangePh: "Ej: 25-35",
    generatedBy: "Generado por",
    nlBadge: "Nuevo · Modo IA",
    nlTitle: "Escríbelo con tus palabras",
    nlPlaceholder: "Ej: Somos 4 amigos con 30€ por cabeza, nos apetece tapas y algo cultural el sábado por Sevilla",
    nlHint: "La IA rellenará los filtros por ti",
    interpret: "Interpretar",
    interpreting: "Interpretando...",
    interpretedOk: "¡Filtros rellenados!",
    interpretError: "No pude interpretar la frase, intenta reformularla",
  },
  en: {
    appName: "Plan Planner",
    tagline: "Tell us how many you are, your budget and what you fancy. We suggest real local plans with prices and how to get there.",
    people: "People",
    budgetPerPerson: "Budget per person (€)",
    mood: "What do you fancy?",
    moodPlaceholder: "nature, adventure, tapas, escape room...",
    maxDistance: "Max distance",
    upTo: "Up to",
    km: "km",
    location: "Your location",
    locationPlaceholder: "e.g. Buendía, Madrid, Valencia...",
    searchPlans: "Find plans",
    searching: "Finding plans...",
    plansCount: (n, p) => `${n} plan(s) for ${p} person(s)`,
    perPerson: "/person",
    totalGroup: "Group total",
    overBudget: (e) => `Over budget by ~€${e}/person`,
    save: "Save",
    saved: "Saved",
    login: "Log in",
    register: "Sign up",
    logout: "Log out",
    email: "Email",
    password: "Password",
    name: "Name",
    loginTitle: "Welcome back",
    registerTitle: "Join the adventure",
    noAccount: "No account?",
    haveAccount: "Have an account?",
    favorites: "My plans",
    emptyFav: "You haven't saved any plans yet.",
    delete: "Delete",
    home: "Home",
    heroBadge: "Real plans · local AI",
    heroTitle: "The perfect plan in 30 seconds",
    heroSub: "Getaways, tapas, adventure and more — tailored to your group.",
    loginToSave: "Log in to save your favorite plans",
    signup: "Sign up",
    aiError: "We couldn't generate plans. Try adjusting your filters.",
    budgetError: "⚠️ AI key is out of credit. Go to Profile → Manage plan → Universal Key → Add balance and try again.",
    rateLimitError: "Too many requests in a row. Wait a few seconds and try again.",
    within: "Within budget",
    generatingSub: "Our AI is scanning the area around {loc}...",
    continueGoogle: "Continue with Google",
    orDivider: "or",
    bookNow: "Book",
    findOnline: "Go to website",
    bookPlan: "Book this plan",
    exploreOnline: "Open plan website",
    aiEngine: "AI engine",
    date: "Date",
    pickDate: "Pick a date",
    withKids: "With kids",
    duration: "Duration",
    halfDay: "Half day",
    fullDay: "Full day",
    weatherAware: "Weather aware",
    surpriseMe: "Surprise me",
    tryAgain: "Not convinced, try again",
    holiday: "Holiday",
    weather: "Weather",
    rainProb: "Rain prob.",
    requiresBooking: "Needs booking",
    noBooking: "No booking needed",
    kidFriendly: "Kid friendly",
    indoor: "Indoor",
    outdoor: "Outdoor",
    duration_h: (h) => `~${h}h`,
    share: "Share",
    shareWhatsapp: "Send by WhatsApp",
    groupVote: "Group vote",
    creatingShare: "Creating link...",
    voteFor: "Vote your favorite",
    voterName: "Your name",
    vote: "Vote",
    voted: "Vote recorded",
    votesCount: (n) => `${n} vote(s)`,
    groupWinner: "Winning plan",
    ratingUp: "We liked it",
    ratingDown: "We didn't like it",
    markDone: "Mark as done",
    marked: "Done",
    filters: "Filters",
    moreFilters: "More filters",
    hideFilters: "Hide filters",
    ageRange: "Age range",
    ageRangePh: "e.g. 25-35",
    generatedBy: "Generated by",
    nlBadge: "New · AI mode",
    nlTitle: "Describe it in your words",
    nlPlaceholder: "e.g. We're 4 friends with 30€ each, want tapas and something cultural on Saturday in Seville",
    nlHint: "AI will fill the filters for you",
    interpret: "Interpret",
    interpreting: "Interpreting...",
    interpretedOk: "Filters filled!",
    interpretError: "Couldn't parse the sentence, try rephrasing",
  },
};
